/**
 * Selector de plazas de garaje (0 / 1 / 2+), mismo criterio que el móvil.
 * Persistir en num_plazas_garaje y sincronizar eq_garaje (n > 0).
 */
import { useState } from "react";

export const GARAJE_PLAZAS_KEYS = [
  "num_plazas_garaje",
  "num_garajes",
  "garajes",
  "plazas_garaje",
  "btn_sel_garajes",
];

export function isGarajePlazasKey(key) {
  return GARAJE_PLAZAS_KEYS.includes(String(key || ""));
}

/** Lee nº plazas desde form/extras; false en eq_garaje legacy → 0. */
export function parseNumPlazasGaraje(src) {
  if (!src || typeof src !== "object") return null;
  for (const k of GARAJE_PLAZAS_KEYS) {
    const raw = src[k];
    if (raw === 0 || raw === "0") return 0;
    if (raw == null || raw === "") continue;
    const n = parseInt(String(raw).replace(/\+$/, ""), 10);
    if (!Number.isNaN(n) && n >= 0) return n;
  }
  if (src.eq_garaje === false || src.eq_garaje === "false") return 0;
  return null;
}

/** Patch de campos al elegir N plazas. */
export function buildGarajePlazasPatch(n) {
  const num = Math.max(0, parseInt(String(n), 10) || 0);
  const patch = {
    num_plazas_garaje: num,
    eq_garaje: num > 0,
  };
  if (num <= 0) {
    patch.num_garaje = "";
    patch.garaje_tipos = [];
    patch.garajes_plazas_detalle = null;
  }
  return patch;
}

export default function GarajePlazasButtons({
  value,
  onChange,
  chipStyle,
  onEnter,
  onLeave,
  disabled = false,
}) {
  const [plusEdit, setPlusEdit] = useState(false);
  const [plusDraft, setPlusDraft] = useState("2");
  const n = value == null || value === "" ? null : Number(value);
  const activo0 = n === 0;
  const activo1 = n === 1;
  const activoPlus = n != null && n >= 2;

  const baseChip = (activo) => {
    if (typeof chipStyle === "function") return chipStyle(activo);
    return {
      padding: "8px 14px",
      fontSize: 13,
      fontWeight: 700,
      borderRadius: 8,
      border: `2px solid ${activo ? "#f59e0b" : "#cbd5e1"}`,
      background: activo ? "#fff7ed" : "#fff",
      color: activo ? "#f59e0b" : "#64748b",
      cursor: disabled ? "not-allowed" : "pointer",
      minWidth: 44,
      opacity: disabled ? 0.5 : 1,
    };
  };

  const elegir = (next) => {
    if (disabled) return;
    setPlusEdit(false);
    onChange?.(next);
  };

  const abrirPlus = () => {
    if (disabled) return;
    if (activoPlus) {
      setPlusDraft(String(n));
      setPlusEdit(true);
      return;
    }
    elegir(2);
  };

  const confirmarPlus = () => {
    const parsed = parseInt(String(plusDraft).replace(/\D/g, ""), 10);
    if (Number.isNaN(parsed) || parsed < 2) return;
    elegir(parsed);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%" }}>
      <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
        {[0, 1].map((v) => {
          const activo = v === 0 ? activo0 : activo1;
          return (
            <button
              key={v}
              type="button"
              disabled={disabled}
              onClick={() => elegir(v)}
              style={baseChip(activo)}
              onMouseEnter={(e) => onEnter?.(e, activo)}
              onMouseLeave={(e) => onLeave?.(e, activo)}
            >
              {v}
            </button>
          );
        })}
        <button
          type="button"
          disabled={disabled}
          onClick={abrirPlus}
          style={baseChip(activoPlus)}
          onMouseEnter={(e) => onEnter?.(e, activoPlus)}
          onMouseLeave={(e) => onLeave?.(e, activoPlus)}
          title={activoPlus ? `${n} plazas (clic para cambiar)` : "2 o más plazas"}
        >
          {activoPlus ? `${n}+` : "2+"}
        </button>
        {activoPlus && !plusEdit && (
          <span style={{ fontSize: 11, color: "#64748b" }}>{n} plazas</span>
        )}
      </div>
      {plusEdit && (
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <input
            type="number"
            min={2}
            inputMode="numeric"
            value={plusDraft}
            onChange={(e) => setPlusDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                confirmarPlus();
              }
            }}
            style={{
              width: 72,
              padding: "6px 8px",
              borderRadius: 6,
              border: "1px solid #cbd5e1",
              fontSize: 13,
            }}
            autoFocus
          />
          <button
            type="button"
            onClick={confirmarPlus}
            style={{ ...baseChip(true), minWidth: "auto", padding: "6px 12px" }}
          >
            OK
          </button>
          <button
            type="button"
            onClick={() => setPlusEdit(false)}
            style={{ ...baseChip(false), minWidth: "auto", padding: "6px 12px" }}
          >
            Cancelar
          </button>
        </div>
      )}
    </div>
  );
}
